import { render, staticRenderFns } from "./VideoWatch.vue?vue&type=template&id=231d03dc&scoped=true&"
import script from "./VideoWatch.vue?vue&type=script&lang=js&"
export * from "./VideoWatch.vue?vue&type=script&lang=js&"
import style0 from "./VideoWatch.vue?vue&type=style&index=0&id=231d03dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d03dc",
  null
  
)

export default component.exports